/**
 * axios setup to use mock service
 */

import axios from 'axios';

const axiosServices = axios.create({ baseURL: import.meta.env.VITE_APP_API_URL || 'http://localhost:3010/' });
axiosServices.interceptors.request.use((config) => {
    // 动态获取参数，例如从localStorage获取locale
    const locale = localStorage.getItem('locale');

    config.headers['Lang'] = locale ? locale : 'tc';

    return config;
});
// interceptor for http
axiosServices.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => Promise.reject((error.response && error.response.data) || 'Wrong Services')
);

export default axiosServices;
